/** Lists the main rail items the person is already authorised to see: a switch each to show or hide it, and drag or the arrows to reorder. */

import React from 'react';

import { Button } from '../../shared/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../shared/ui/dialog';
import { RailOrderList, type RailOrderItem } from '../../features/preferences/components/RailOrderList';
import { MAIN_RAIL_PINNED_IDS } from './useMainRailPreferences';

export type CustomiseRailItem = RailOrderItem;

export function CustomiseRailDialog({
  open,
  onOpenChange,
  items,
  hiddenSet,
  onToggle,
  onOrderChange,
  onReset,
  canReset,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Every rail item, already in the person's order. */
  items: readonly CustomiseRailItem[];
  hiddenSet: ReadonlySet<string>;
  onToggle: (id: string, hidden: boolean) => void;
  onOrderChange: (ids: string[]) => void;
  onReset: () => void;
  canReset: boolean;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Customise navigation</DialogTitle>
          <DialogDescription>Choose which items appear in the main rail, and their order. Home always comes first.</DialogDescription>
        </DialogHeader>
        <div className="max-h-[50vh] overflow-y-auto -mx-1 px-1" data-slot="customise-rail-list">
          <RailOrderList
            items={items}
            hiddenSet={hiddenSet}
            pinnedIds={MAIN_RAIL_PINNED_IDS}
            onOrderChange={onOrderChange}
            onToggle={onToggle}
            onReset={onReset}
            canReset={canReset}
          />
        </div>
        <DialogFooter>
          <Button type="button" onClick={() => onOpenChange(false)}>Done</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
